import React from "react";

const ASP_Server = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Server</h1>
      <p>This is the ASP Server page content.</p>
    </div>
  );
};

export default ASP_Server;
